
import { GetMailTemplateListConst, GetScheduleSendMailUsing365ListConst, GetSentMailListConst, ReplyEmailPayload } from "../constant/EmailConstant";

import { GetMailTemplateListService, GetScheduleSendMailUsing365ListService, GetSentMailListService } from "../service/MailService";

export const GetScheduleSendMailUsing365Action = (page={limit:0,page:1}) => async (dispatch) => {
  try {
    const response = await GetScheduleSendMailUsing365ListService(page);
    const payload = response?.data ?? response;

    dispatch({ type: GetScheduleSendMailUsing365ListConst, payload });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetScheduleSendMailUsing365ListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetSentMailAction = (page={limit:0,page:1}) => async (dispatch) => {
  try {
    const data = await GetSentMailListService(page);

    dispatch({ type: GetSentMailListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetSentMailListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetMailTemplateAction = () => async (dispatch) => {
  try {
    const data = await GetMailTemplateListService();

    dispatch({ type: GetMailTemplateListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetMailTemplateListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};


export const SetMailReplyPayload = (payload)=> async (dispatch) => {
  try {
    dispatch({ type: ReplyEmailPayload, payload });
  } catch (error) {
    dispatch({ type: ReplyEmailPayload, payload: error });
  }
}


